import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useMemo,
  useState,
} from 'react';

type EntityMetaContextProps = {
  templateId: number;
  templateRowVersion: string;
  mappingRowVersion: string;
  mappingCreatedAt: string;
  setTemplateId: Dispatch<SetStateAction<number>>;
  setTemplateRowVersion: Dispatch<SetStateAction<string>>;
  setMappingRowVersion: Dispatch<SetStateAction<string>>;
  setMappingCreatedAt: Dispatch<SetStateAction<string>>;
};

const EntityMetaContext = createContext<EntityMetaContextProps>(
  {} as EntityMetaContextProps
);

export function EntityMetaContextProvider({
  children,
}: {
  children: ReactNode;
}): ReactNode {
  const [templateId, setTemplateId] = useState(0);
  const [templateRowVersion, setTemplateRowVersion] = useState('');
  const [mappingRowVersion, setMappingRowVersion] = useState('');
  const [mappingCreatedAt, setMappingCreatedAt] = useState('');

  const value = useMemo(
    () => ({
      templateId,
      templateRowVersion,
      mappingRowVersion,
      mappingCreatedAt,
      setTemplateId,
      setTemplateRowVersion,
      setMappingRowVersion,
      setMappingCreatedAt,
    }),
    [templateId, templateRowVersion, mappingRowVersion, mappingCreatedAt]
  );

  return (
    <EntityMetaContext.Provider value={value}>
      {children}
    </EntityMetaContext.Provider>
  );
}

export const useEntityMeta = () => useContext(EntityMetaContext);
